// Canvas.js (Updated)
import React, {useState} from 'react';
import DinningTable from './DinningTable';
import './Canvas.css';
import useUserStore from "../../stores/store";
import DinningTableForAdmin from "./DinningTableForAdmin";

export const CANVAS_CONSTANT = {
  VIEW: "view",
  EDIT: "edit",
};

function Canvas({
  // 2. Receive all state as props
  tables,
  mode,
  // 3. Receive all event handlers as props
  onTablesChange,
  onTableClick,
  selectedTableIds = [],
  allowMultiSelect = false,
}) {
  const { isSuperAdmin } = useUserStore();
  // This function updates the state when a drag stops
  const handleDragStop = (id, e, data) => {
    const newTables = tables.map((table) => (table.id === id ? { ...table, x: data.x, y: data.y } : table));
    onTablesChange(newTables); // Send the updated array to the parent
  };

  // This function updates the state when a resize stops
  const handleResizeStop = (id, e, data, newSize) => {
    const newTables = tables.map((table) =>
      table.id === id ? { ...table, width: newSize.width, height: newSize.height } : table
    );
    onTablesChange(newTables); // Send the updated array to the parent
  };

  const onTableClicked = (value) => {
    onTableClick(value, allowMultiSelect);
  };

  return (
    <div>
      <div className="canvas">
        {tables?.length > 0 ? (
          tables?.length > 0 && tables.map(table => (
            isSuperAdmin ? (
              <DinningTable
                key={table.id}
                data={table}
                // 8. Pass all props down to the child
                mode={mode}
                onTableClick={()=> {}}
                onDragStop={handleDragStop}
                onResizeStop={handleResizeStop}
                isSelected={selectedTableIds.includes(table.id)}
              />
            ):(
              <DinningTableForAdmin
                key={table.id}
                data={table}
                onTableClick={onTableClicked}
                isSelected={selectedTableIds.includes(table.id)}
              />
            )

          ))
        ):(
          <div className="flex items-center justify-center h-full text-xl font-bold">
          No tables found!
          </div>
          )}

      </div>
    </div>
  );
}

export default Canvas;
